/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_Payment_MethodInputs */

const vi_expense_payment_method = /** @type {(inputs: Expense_Payment_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phương thức thanh toán`)
};

/**

* @param {Expense_Payment_MethodInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_payment_method = /** @type {((inputs?: Expense_Payment_MethodInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_Payment_MethodInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_payment_method(inputs)
});